import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  FollowUp,
  FollowUpActivity,
  FollowUpsUser,
} from '@app/modules/follow-ups/follow-ups.types';
import { FollowUpsState } from '@app/modules/follow-ups/store/follow-ups.state';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableConfiguration,
  DataTableDataType,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { TranslatePipe } from '@ngx-translate/core';
import { DisplayNamePipe } from '@shared/pipes/display-name.pipe';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-follow-up-timeline',
  imports: [DataTableComponent, DisplayNamePipe, TranslatePipe],
  templateUrl: './follow-up-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './follow-up-timeline.component.scss',
})
export class FollowUpTimelineComponent implements OnInit {
  private store = inject(Store);

  @Input()
  set followUp(value: FollowUp) {
    this.timeline$.next(value.timeline.toReversed());
  }

  users: FollowUpsUser[] = [];
  private timeline$ = new BehaviorSubject<FollowUpActivity[]>([]);

  dataTableConfiguration: DataTableConfiguration;

  @ViewChild('detailsRow', { static: true })
  detailsRow: TemplateRef<any>;

  ngOnInit() {
    this.users = this.store.selectSnapshot(FollowUpsState.getFollowUpsUsers);
    this.dataTableConfiguration = {
      title: 'followUps.timeline.title',
      selectionMode: DataTableSelectionType.NONE,
      columns: [
        {
          label: 'followUps.timeline.columns.activity',
          property: 'type',
        },
        {
          label: 'followUps.timeline.columns.user',
          invoke: {
            objectReference: {
              getName: (activity: FollowUpActivity) =>
                new DisplayNamePipe().transform(activity.by, this.users),
            },
            name: 'getName',
            args: [],
          },
        },
        {
          label: 'followUps.timeline.columns.timestamp',
          property: 'timestamp',
          type: DataTableDataType.DATETIME,
        },
      ],
      extraRow: this.detailsRow,
      rows$: this.timeline$,
    };
  }
}
